import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ignoredEndpoints } from './error-ignore.config';

interface ApiResponse {
  status: boolean;
  data: {
    code: string;
    message: string;
    response?: any;
  };
  validation?: boolean;
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  ignoreList = ignoredEndpoints;
  constructor(
    private readonly router: Router,
    private readonly messageService: MessageService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          const body = event.body as ApiResponse;
          if (body && body.status === true) {
            return event;
          } else if (
            body &&
            body.status === false &&
            body.validation &&
            !this.isIgnoredEndpoint(request.url)
          ) {
            return event;
          } else if (
            body &&
            body.status === false &&
            !this.isIgnoredEndpoint(request.url)
          ) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: body.data.message,
            });
            const error = new Error(body.data.message);
            (error as any).code = body.data.code;
            throw error;
          }
        }
        return event;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  isIgnoredEndpoint(url: string): boolean {
    const segments = url.split('/');
    return ignoredEndpoints.some(
      (endpoint) => segments[segments.length - 1] === endpoint
    );
  }
}
